import React, { Component } from 'react'
import moment from 'moment-timezone'
import { withStyles } from '@material-ui/core/styles'
import { DEFAULT_TIMEZONE} from '../constants'

const styles = theme => ({
  root: {
    margin: '20px 0'
  },
  active: {
    color: 'red',
  },
  date: {
    fontSize: '0.8rem'
  }
})

class Notification extends Component {
  duration () {
    const { time, end } = this.props.notification
    const startTime = moment.utc(time).tz(DEFAULT_TIMEZONE)
    let endTime
    if (end) {
      endTime = moment.utc(end).tz(DEFAULT_TIMEZONE)
    } else {
      endTime = moment.utc().tz(DEFAULT_TIMEZONE)
    }
    const duration = moment.duration(endTime.diff(startTime)).humanize()
    return duration
  }

  render () {
    const { notification, classes } = this.props
    const { active, text, time } = notification

    return (
      <div className={classes.root} style={{color: active ? 'black' : 'silver'}}>
        <strong>
          <span className={classes.active}> { active ? '!' : ''} </span>
          {text}
        </strong>
        <span className={classes.date}> { `${moment.utc(time).tz(DEFAULT_TIMEZONE).format('MMMM DD YYYY hh:mm A')} – ${this.duration()}` } </span>
        <span>{active ? '+' : ''}</span>
      </div>
    )
  }
}

export default withStyles(styles)(Notification)



// WEBPACK FOOTER //
// ./src/components/Notification.js